import { render, staticRenderFns } from "./WidgetTheme.vue?vue&type=template&id=36a842fa&scoped=true"
import script from "./WidgetTheme.vue?vue&type=script&lang=js"
export * from "./WidgetTheme.vue?vue&type=script&lang=js"
import style0 from "./WidgetTheme.vue?vue&type=style&index=0&id=36a842fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a842fa",
  null
  
)

export default component.exports